import React, { useState } from "react";
import { PageHeader, Tabs } from "antd";

//api
import util from "helpers/util";
import CreateTake from "./CreateTake";
import TakeList from "./TakeList";
import UploadStockTakeResult from "./UploadStockTakeResult";

const { TabPane } = Tabs;

export default function ItemTake() {
  const [tabActiveKey, setTabActiveKey] = useState("1");

  const urlDetail = util.getCurrentUrlDetail();

  const callbackTab = (key) => {
    setTabActiveKey(key);
  };

  // return (
  return util.isIn(urlDetail.subPath, ["uploadstocktakeresult"]) ? (
    <UploadStockTakeResult />
  ) : (
    <>
      <PageHeader title="Stock Take" />
      <br />
      <Tabs
        defaultActiveKey="1"
        activeKey={tabActiveKey}
        onChange={callbackTab}
        type="card"
        size="large"
      >
        <TabPane tab="Take Initiation" key="1">
          <CreateTake />
        </TabPane>

        <TabPane tab="Take Lists" key="2">
          <TakeList />
        </TabPane>
      </Tabs>
    </>
  );
  // );
}
